export default __webpack_public_path__ + "9ce782a798e502c71e1140e298c6ad17.png";